import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalBarEmployeeSubstitutionComponent } from '@app/components/util/modal-bar-employee-substitution/modal-bar-employee-substitution.component';
import { NavigationBarEmployeeConfigComponent } from '@app/components/util/navigation-bar-employee-config/navigation-bar-employee-config.component';
import { NavigationBarEmployeeSubstitutionComponent } from '@app/components/util/navigation-bar-employee-substitution/navigation-bar-employee-substitution.component';
import { profile_access_module } from '@app/config/role-name.enum';
import { path_module_admin, path_module_employer, path_module_public } from '@app/models/routes.name';
import { ConstantsService } from '@app/services/constants.service';
import { DataService } from '@app/services/data.service';
import { EmployeeService } from '@app/services/employee.service';
import { InjectorModalService } from '@app/services/injectorModal.service';
import { PlatformService } from '@app/services/platform.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';

declare var $: any;
declare function dropdownMultilevelMenu(): any;

@Component({
  selector: 'header-style-default',
  templateUrl: './header-style-default.component.html',
  styleUrls: ['./header-style-default.component.css'],
})
export class HeaderStyleDefaultComponent implements AfterViewInit {

  public path_module_employer = path_module_employer;
  public path_module_public = path_module_public;
  public path_module_admin = path_module_admin;

  public innerWidth1200: boolean = false;

  @HostListener('window:resize', ['$event'])

  getScreenSize(event?) {
    this.innerWidth1200 = window.innerWidth >= 1200;
  }

  @ViewChild('navigationBarEmployeeConfig') navigationBarEmployeeConfig: NavigationBarEmployeeConfigComponent;
  // @ViewChild('navigationBarEmployeeSubstitutionMobile') navigationBarEmployeeSubstitutionMobile: NavigationBarEmployeeSubstitutionComponent;
  // @ViewChild('navigationBarEmployeeSubstitutionDesktop') navigationBarEmployeeSubstitutionDesktop: NavigationBarEmployeeSubstitutionComponent;
  // @ViewChild('modalBarEmployeeSubstitution') modalBarEmployeeSubstitution: ModalBarEmployeeSubstitutionComponent;

  constructor(public userService: UserService,
    public constantsService: ConstantsService,
    private router: Router,
    private employeeService: EmployeeService,
    private platformService: PlatformService,
    private dataService: DataService,
    private injectorModalService: InjectorModalService) {
    this.getScreenSize();
  }
  /*ngOnInit(): void {

    this.dataService.sharedData.subscribe(data => {

      if (data.module && data.module === 'login') {
        this.loadSubstitutionEmployee();
      }
    });

    this.loadSubstitutionEmployee();
  }*/

  /* loadSubstitutionEmployee() {
    if (this.userService.getIdEmployee() > 0) {

      this.employeeService.getEmployeeProfileSubstitution(this.userService.getIdEmployee()).toPromise().then(
        res => {

          if (res.status_code === status_code.success) {

            this.navigationBarEmployeeSubstitutionMobile.setValue(+res.flagSubstitute, +res.employeeSubstitution);
            this.navigationBarEmployeeSubstitutionDesktop.setValue(+res.flagSubstitute, +res.employeeSubstitution);
            this.modalBarEmployeeSubstitution.setSubstituteEnabled(+res.flagSubstitute === 1);

            if (Array.isArray(res.employeeSubstitutionAvailability)) {
              this.modalBarEmployeeSubstitution.populate(Array.from(res.employeeSubstitutionAvailability))
            }

          }
          this.navigationBarEmployeeSubstitutionMobile.showContainer();
          this.navigationBarEmployeeSubstitutionDesktop.showContainer();

        },
        () => {
          this.navigationBarEmployeeSubstitutionMobile.showContainer();
          this.navigationBarEmployeeSubstitutionDesktop.showContainer();
        }
      );
    }
  }*/



  /* onEventOpenModalSubstitute(event: MouseEvent) {

    this.modalBarEmployeeSubstitution.actionOpenModal(event);

  } */ 

  /*onEventSaveSubstitute(value: any) {

    if (value === true) {
      this.modalBarEmployeeSubstitution.actionOpenModal(undefined);
    }

    this.navigationBarEmployeeSubstitutionMobile.updateValueSubstitute(value);
    this.navigationBarEmployeeSubstitutionDesktop.updateValueSubstitute(value);
  }*/



  ngAfterViewInit(): void {
    if (this.platformService.isPlatformBrowser)
      $('.dropdown-multilevel-menu').each(dropdownMultilevelMenu);
  }

  openDropdownPreferences() {

    setTimeout(() => {
      $("#dropdownMainMenuPS").click();
    }, 100);
  }

  /* onCancelActionSubstitution() {
    this.navigationBarEmployeeSubstitutionMobile.resetState();
    this.navigationBarEmployeeSubstitutionDesktop.resetState();
  } */

  onClickEditUser(event: MouseEvent) {
    event.preventDefault();

    if (this.userService.hasAccessToModule(profile_access_module.employer_user))
    {
      this.injectorModalService.openModal();
      return;
    }

    this.router.navigate([path_module_employer.module, path_module_employer.users]);
  }
}
